<template>
    <section class="p-3 pt-6 lg:p-12 bg-black text-white flex flex-col lg:flex-row-reverse lg:h-[750px] lg:gap-[100px]">
        <div class="lg:w-2/3 lg:flex-1">
            <div class="text-sm relative">
                <span class="lg:hidden floating-right-div"></span>
                <p>
                    <span class="w-1/3 h-[100px] float-left lg:h-[70px] lg:w-1/2"></span>
                    La danse contemporaine est un langage corporel qui transcende les mots. À travers les mouvements, nous  communiquons des émotions, des idées et des récits profonds qui ne peuvent être exprimés par des moyens conventionnels. C'est une forme d'expression qui nous permet de nous connecter avec les autres d'une manière pure et authentique.
                </p>
            </div>

            <p class="mt-12 mb-40 lg:uppercase">William Forsythe <span class="material-symbols-outlined text-sm">north_east</span></p>
        </div>

        <div class="flex justify-end lg:self-end">
            <img class="h-[300px] w-[250px] lg:h-[400px] lg:w-[330px] object-center object-cover" src="https://fakeimg.pl/250x100/ff0000/" alt="">
        </div>
    </section>
</template>

<script>
export default {
    name: 'OrganismFolderQuote',
}
</script>

<style lang="scss" scoped>
.floating-right-div {
    --top: 100px;
    --width: 35%;
    --bottom: 350px;

    width:  var(--width);
    height: calc(var(--bottom));
    transform: translate(0, var(--top));
    float: right;

    shape-outside: polygon(0 var(--top), var(--width) var(--top), var(--width) var(--bottom), 0 var(--bottom));

    clip-path: polygon(0 0, var(--width) 0, var(--width) calc(var(--bottom) - var(--top)), 0 calc(var(--bottom) - var(--top)));
}
</style>
